// extracted by mini-css-extract-plugin
export var quillEditor = "_np-1";
export var variable = "_np-0";